var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m408.299 98.512-32.643 371.975H136.344L103.708 98.512l-41.354 3.625 33.232 378.721C97.335 498.314 112.481 512 130.076 512h251.849c17.588 0 32.74-13.679 34.518-31.391l33.211-378.472-41.355-3.625z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.108 0H179.892c-19.076 0-34.595 15.519-34.595 34.595v65.73h41.513V41.513h138.378v58.811h41.513v-65.73C366.703 15.519 351.184 0 332.108 0z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.405 79.568H34.595c-11.465 0-20.757 9.292-20.757 20.757s9.292 20.757 20.757 20.757h442.811c11.465 0 20.757-9.292 20.757-20.757s-9.293-20.757-20.758-20.757z",
    fill: "#000000",
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.14a8d79269310d7f257376cc0773dd1f.svg";
export { ForwardRef as ReactComponent };